<template>
  <div class="shipping-po">
    <CustomTitle :title="mytitle"/>
    <div class="table-header df-c" :style="{
    fontSize: fontsize + 'px',
    lineHeight: (fontsize * 1.25) + 'px',   
    // color: '#bae3e6'
  }">
      <span class="index">#</span>
      <span v-for="(item, index) in tableHeader" :key="index" :style="{flex:item=='客户PO'||item=='模号'?'1.7':'1'}">{{ item }}</span>
    </div>
    <div class="scroll-chart">
      <vue-seamless-scroll :data="tableData" class="warp" :class-option="classOption">
        <template v-for="(item, index) in tableData">
          <div class="table-item df-c" :key="index" ref="TableItem" :style="{
    fontSize: fontsize + 'px',
    lineHeight: (fontsize * 1.25) + 'px',   
    // color: '#bae3e6'
  }">
            <span class="index">{{index+1}}</span>
            <span class="overflow-text" style="flex:1.7">{{item.PartNu}}</span>
            <span class="overflow-text" v-if="isShowPo === '1'" style="flex:1.7" :title="item.PO">
              {{item.PO}}</span>
            <span class="overflow-text" v-if="isShowMo === '1'" style="flex:1.7;text-align:center" :title="item.MouldName">{{item.MouldName?item.MouldName.substr(-13):item.MouldName}}</span>
            <!-- <span
              class="overflow-text"
              :style="{color:item.Precedence=='急件'?'#FBCF5B':'#FFA8B6'}"
            >{{item.Precedence}}</span> -->
            <!-- <span class="overflow-text">{{echoTime(item.ProTime)}}</span> -->
            <span class="overflow-text">{{item.PartTitle}}</span>
            <span
              class="overflow-text"
              :style="{color:echoColor(item.FinDate)}"
            >{{echoTime(item.FinDate)}}</span>
            <span
              class="overflow-text"
              :style="{color:echoColor(item.PMDDate)}"
            >{{echoTime(item.PMDDate)}}</span>
            <span class="overflow-text">{{item.ProSet}}</span>
            <span class="overflow-text">{{item.CurDEP}}</span>
            <span class="overflow-text">{{item.StatusStr}}</span>
            <!-- <span class="overflow-text">{{item.Proset}}</span>
            <span class="overflow-text">{{item.NoOKPCS}}</span> -->
            <!-- <span class="overflow-text" :title="item.Detail4">{{item.Detail4}}</span> -->
            <!-- <span class="overflow-text">{{item.Detail1}}</span> -->
          </div>
        </template>
      </vue-seamless-scroll>
    </div>
  </div>
</template>

<script>
import CustomTitle from '@/components/CustomTitle'
import vueSeamlessScroll from 'vue-seamless-scroll'
import { speak } from '@/utils/speech';
import config from '@/js/config'
import moment from 'moment'
export default {
  name: 'Shippingpo',
  data () {
    return {
      compid: -1,
      dept: '',
      mytitle:"今日出货表",
      tableHeader: [
        '工号',
        '客户PO',
        '模号',
        '图号',
        // '特急',
        // '下单',
        '厂内',
        '生管',
        '数量',
        '部门',
        '状态'
        // '总件数',
        // '未完件数',
        // '备注'
      ],
      tableData: [],
      classOption: {
        step: 0.5
      },
      requestTimer: null,
      isShowPo: '',
      isShowMo: '',
      isBusy:'',
      nowDay: moment().format('YYYY-MM-DD'),
      afterThreeDay: moment().add(2, 'days').format('YYYY-MM-DD'),
      requestUrl:'',
      retryTimer: null, // 重试延时器
      fontsize:16,
      speakstr:'',
    }
  },
  methods: {
    getPOparts () {
      clearTimeout(this.retryTimer)
      //
        this.compid = window.localStorage.getItem('bsmcompid')
        this.dept = window.localStorage.getItem('bsmdept')
      //}
      this.isShowPo = window.localStorage.getItem('isShowPo')
      this.isShowMo = window.localStorage.getItem('isShowMo')
      var ttp= window.localStorage.getItem('bsmisbrushpcs')
      if(ttp>0)
        this.classOption.step=ttp;

       var fnt= window.localStorage.getItem('bsmisfontsize')
       if(fnt>10)
         this.fontsize=fnt;
     
      var pa = {
        datekind: 1,
        dst: '',
        ded: '',
        compid: this.compid
      }
      this.axios({
        method: 'post',
        // params: pa,
        //url: '/admin.php/Bigsreen/SalepropoFun'
        url: this.requestUrl+'/admin.php/Bigsreen/SalePartPMDDateFun?datekind=0&status=-1&compid='+this.compid+'&dst=&ded='
      })
        .then((Response) => {
          var data = JSON.parse(Response.data)
          // console.log(data)
          // 登录未勾选po
          if (this.isShowPo === '2' || !this.isShowPo) {
            this.tableHeader = this.tableHeader.filter(
              (item) => item !== '客户PO'
            )
          }
          // 登录未勾选mo
          if (this.isShowMo === '2' || !this.isShowMo) {
            this.tableHeader = this.tableHeader.filter(
              (item) => item !== '模号'
            )
          }
          this.tableData = data['rows']
          this.speakstr=data["speek"]
          speak("今日需出货工号 "+this.speakstr);
          // console.log(this.speakstr)
          // this.speakfun()

        })
        .catch((error) => {
          // 异常30s进行重试
          console.log(error+" ShippingSchedule")
          this.retryTimer = setTimeout(() => {
            this.getPOparts()
          }, config.retryTime)
        })
    },
    // 回显日期
    echoTime (time) {
      if (time) {
        // time=time.replaceAll("/","-");
        // console.log(time);
        var timeArr = time.split('-')
        return timeArr[1] + '-' + timeArr[2]
      }
      return ''
    },
    // 回显颜色
    echoColor (time) {
      if (!time) {
        return '#fff'
      }
      if (time < this.nowDay) {
        return '#FFA8B6'
      }
      if (time >= this.nowDay && time <= this.afterThreeDay) {
        return '#FBCF5B'
      }
      return '#fff'
    },
  },
  created () {
    this.requestUrl=window.localStorage.getItem('requestUrl')
    this.getPOparts()
  },
  mounted () {
    this.requestTimer = setInterval(() => {
      this.getPOparts()
    }, config.refreshTime.shippingSchedule),
    this.speektTimer = setInterval(() => {      
        // this.$forceUpdate();       
      if(this.speakstr.length>0)
      {       
        // const utterance = new SpeechSynthesisUtterance("今日需出货工号 " + this.speakstr);
        // utterance.rate = 0.6; // Slower speech rate (default is 1, range is 0.1-10)
        // speechSynthesis.speak(utterance);
         speak("今日需出货工号 "+this.speakstr);
      }
        console.log("<run>")
    }, 10 * 60 * 1000)// config.refreshTime.onemm*1000)
  },
  beforeDestroy () {
    clearInterval(this.requestTimer)
    clearInterval(this.speektTimer)
    clearTimeout(this.retryTimer)
  },
  components: {
    CustomTitle,
    vueSeamlessScroll
  },
  watch: {}
}
</script>

<style scoped lang="less">
.shipping-po {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 8px 8px !important;
  .table-header {
    margin-top: 8px;
    background: linear-gradient(0deg, #1b6787 -24.83%, #4aaef7 100%);
    padding: 0 16px;
    border-radius: 8px 8px 0px 0px;
    .index {
      width: 30px;
      flex: unset;
    }
    span {
      flex: 1;
      padding: 7px 2px;
      text-align: center;
      // height: 22px;
      font-family: 'PingFang SC';
      font-weight: 500;
      // font-size: 32px;
      // line-height: 40px;
      color: #ffffff;
      &:nth-child(2){
        flex: 1.7 !important;
      }
    }
  }
  .table-item {
    cursor: pointer;
    padding: 0 16px;
    .index {
      width: 30px;
      flex: unset;
    }
    span {
      flex: 1;
      padding: 5px 2px;
      text-align: center; 
      // height: 22px;
      font-family: 'PingFang SC';
      font-weight: 500;
      // font-size: 32px; 
      //font-size: 14px; 
      // line-height: 40px;
      color: #bae3e6;
      &:nth-child(2){
        flex: 1.7 !important;
      }
    }
  }

  .scroll-chart {
    flex: 1;
    // height: 0;
    min-height: 100px;
    overflow: hidden;
    border: 1px solid #2dcdff;
    border-top: 0;
    border-radius: 0px 0px 8px 8px;
    .warp {
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/bigscreenSales/components/ShippingShipPartsall.vue